import React from 'react';
import { Col, Form, Row, Typography, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const PeriodSelection = ({ form, periodType }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Fatturato del')}</Typography.Title>
      </Col>
      <Col span={9}></Col>
      <Col offset={6} span={9}>
        <Form.Item
          name='period_type'
          rules={[
            { required: true, message: t('Please select a period type') },
          ]}
        >
          <Select style={{ width: '100%' }}>
          
              <>
                <Select.Option value='year'>{t('Annuale')}</Select.Option>
                <Select.Option value='first_half'>
                  {t('Primo semestre')}
                </Select.Option>
                <Select.Option value='last_half'>
                  {t('Secondo semestre')}
                </Select.Option>
              </>
       
            {/* {periodType === 'half_year' && (
              <>
                <Select.Option value='first_half'>
                  {t('Primo semestre')}
                </Select.Option>
                <Select.Option value='last_half'>
                  {t('Secondo semestre')}
                </Select.Option>
              </>
            )} */}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default PeriodSelection;
